import type { ResponsiveOptions } from './types'
import { twSrOnly } from './style/srOnly'
import { twNotSrOnly } from './style/notSrOnly'

/**
 * This function can take either a object or a boolean and
 * return a string with correct css classnames.
 * @param {(object|boolean)} [hiddenOptions=true] - An object
 * parameter of breakpoints with boolean values or a boolean value
 * @return {string} A string with correct css classnames
 *
 * @example
 * getSrOnlyClasses(true)
 * // => 'ds-sr-only'
 *
 */
export const getSrOnlyClasses = (
  hiddenOptions: ResponsiveOptions | boolean
) => {
  switch (typeof hiddenOptions) {
    case 'boolean': {
      if (twNotSrOnly.default && twSrOnly.default) {
        return hiddenOptions ? twNotSrOnly.default.sm : twSrOnly.default.sm
      } else {
        return twNotSrOnly?.default?.sm
      }
    }
    case 'object': {
      const srClasses = new Array<string>()
      Object.keys(hiddenOptions).forEach((key) => {
        if (hiddenOptions[key as keyof typeof hiddenOptions] as boolean) {
          const selectedSize = twSrOnly[key as keyof typeof twSrOnly]
          const selectedOption =
            selectedSize && selectedSize[key as keyof typeof selectedSize]
          selectedOption && srClasses.push(selectedOption as string)
        } else {
          const selectedSize = twNotSrOnly[key as keyof typeof twNotSrOnly]
          const selectedOption =
            selectedSize && selectedSize[key as keyof typeof selectedSize]
          selectedOption && srClasses.push(selectedOption as string)
        }
      })
      return srClasses.filter(Boolean).join(' ')
    }
    default:
      return 'default'
  }
}
